export const MAX_PRIORITY = 5;
export const MEDIUM_PRIORITY = 3;
export const MIN_PRIORITY = 1;
